import React, { useEffect } from 'react';

/**
 * Si OAuth de Twitch apunta por error al dominio admin, reenvía al sitio público
 * con el mismo ?code=... para completar el login allí.
 */
const PUBLIC_CALLBACK = 'https://eugenial.com.ar/auth/twitch/callback';
const LEGACY_ADMIN_CALLBACK = 'https://admin-eugenial.capitansalto.com.ar/auth/twitch/callback';

const TwitchCallbackRedirectPage: React.FC = () => {
  useEffect(() => {
    const qs = new URLSearchParams(window.location.search);
    if (!qs.has('oauth_redirect_uri')) {
      qs.set('oauth_redirect_uri', LEGACY_ADMIN_CALLBACK);
    }
    const target = `${PUBLIC_CALLBACK}?${qs.toString()}`;
    window.location.replace(target);
  }, []);

  return (
    <div style={{ padding: '2rem', color: '#fff', fontFamily: 'Poppins, sans-serif' }}>
      <h1 style={{ color: '#FF1493', fontFamily: 'Orbitron, sans-serif' }}>Redirigiendo login Twitch...</h1>
      <p style={{ color: '#B8A9C9' }}>Si no pasa nada, abrí eugenial.com.ar e intentá de nuevo.</p>
    </div>
  );
};

export default TwitchCallbackRedirectPage;
